const API_HOST = 'https://dev-api-workspace.softsale.kz';
export const environment = {
  production: false,
  apiV1Url: `${API_HOST}/v1`,
  authUrl: `${API_HOST}/auth`,
  cdnUrl: `${API_HOST}/cdn`,
};
